module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/10@3x.png?0.0.53";